import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import APIs from "../../Constants/apis";

/**
 * Public page: user opens verification link from email (?token=...).
 */
export default function VerifyCompanyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token || !token.trim()) {
      setStatus("error");
      setMessage("Missing verification token.");
      return;
    }

    axiosInstance
      .post(APIs.POST_CONFIRM_COMPANY_EMAIL_CHANGE, { token: token.trim() })
      .then((res) => {
        const ok =
          res.status < 400 && res.data?.status === true;
        if (ok) {
          setStatus("success");
          setMessage(
            res.data?.message ||
              "Company email updated. Sign in with your new email if that is your Back Office login."
          );
        } else {
          setStatus("error");
          setMessage(res.data?.message || "Verification failed.");
        }
      })
      .catch((err) => {
        setStatus("error");
        setMessage(
          err.response?.data?.message ||
            err.message ||
            "Verification failed. The link may have expired."
        );
      });
  }, [searchParams]);

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center p-4"
      style={{
        background:
          "linear-gradient(135deg, rgba(17,24,39,1) 0%, rgba(31,41,55,1) 45%, rgba(55,65,81,1) 100%)",
      }}
    >
      <div
        className="card border-0 shadow-lg"
        style={{
          maxWidth: "520px",
          width: "100%",
          backgroundColor: "#1f2937",
          borderRadius: "14px",
        }}
      >
        <div className="card-body p-4 p-md-5 text-center">
          <h1 className="h5 mb-3 text-white">Confirm company email change</h1>
          {status === "loading" && (
            <p className="mb-0" style={{ color: "#d1d5db" }}>
              Verifying your request...
            </p>
          )}
          {status === "success" && (
            <>
              <p className="mb-3" style={{ color: "#34d399" }}>
                {message}
              </p>
              <Link to="/" className="btn btn-primary px-4">
                Go to home
              </Link>
            </>
          )}
          {status === "error" && (
            <>
              <p className="mb-3" style={{ color: "#f87171" }}>
                {message}
              </p>
              <Link to="/" className="btn btn-outline-light px-4">
                Go to home
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
